var r=(o=>(o.column="column",o.row="row",o))(r||{});export{r as Variants};
